// Copyright (c) 2016 Deere & Company

import { buildDate } from './build-date';

export const buildCityStateZip = (address) => address.city ? `${address.city}, ${address.state} ${address.postalCode}` : '';

export const buildCustomerAddress = (customer) => {

    if (customer.physicalAddress.line1) {

        return customer.physicalAddress;

    }

    return customer.mailingAddress;

};

export const buildEmailLink = (email) => `mailto: ${email}`;

export const buildPhoneLink = (phone) => `tel: ${phone.areaCode}${phone.number}`;

export const buildPhoneNumber = (phone) => {

    if (phone && phone.number) {

        return phone.areaCode ? `(${phone.areaCode}) ${phone.number}` : phone.number;

    }

    return '';

};

export const buildProductName = (product) => `${product.modelYear} ${product.make} ${product.model}`;

export const buildUseAmount = (useAmount) => `${useAmount.amount} ${useAmount.unit.value}`;

export const buildUseAmountList = (useAmountList) => {

    const formattedUseAmounts = useAmountList.map((useAmount) => buildUseAmount(useAmount));

    return formattedUseAmounts.join(', ');

};

export const buildProductUseAmount = (useAmount, lastUpdated) => `${buildUseAmount(useAmount)} (${buildDate(lastUpdated, '6')})`;

export const isRegistrationDisabled = (product) => product.registrationAllowed === 'N';
